module.exports = __webpack_public_path__ + "d1ca74cc893dd73a799fab66f622506b.svg";